import axios from 'axios';
import { API2_HOST } from '../../helpers/urlHelper';
axios.defaults.withCredentials = true;
import {
  baseGet,
  baseGetWithoutParam
} from 'services/base-services/baseService';
import { objectToQueryString } from 'helpers/utils';
const getByEmplasCode = async code => {
  return baseGet(`${API2_HOST}/sls-products/by-emplas-code`, `?code=${code}`);
};

const getBySupplierCode = async code => {
  return baseGet(`${API2_HOST}/sls-products/by-supplier-code`, `?code=${code}`);
};

// Returns up to 20 SlsProductRS, no paging.
const searchProductsStartsWith = async ({ productCode, supplierCode, description }) => {
  const params = {};
  if (productCode) params.productCode = productCode;
  if (supplierCode) params.supplierCode = supplierCode;
  if (description) params.description = description;
  return baseGetWithoutParam(
    `${API2_HOST}/sls-products/search-starts-with?${objectToQueryString(params)}`
  );
};

const searchProducts = async productIds => {
  if (!Array.isArray(productIds) || productIds.length === 0) {
    console.warn(
      'ProductIds is not an array or is empty, skipping API call.'
    );
    return;
  }

  const validIds = productIds.filter(
    id => id !== undefined && id !== null && id !== ''
  );

  if (validIds.length === 0) {
    console.warn('No valid productIds found, skipping API call.');
    return;
  }

  const queryString = validIds
    .map(id => `productIds=${encodeURIComponent(id)}`)
    .join('&');

  console.log(queryString);

  const url = `${API2_HOST}/sls-products/product-info?${queryString}`;
  console.log('✅ Request URL:', url);

  try {
    const res = await baseGetWithoutParam(url, '');
    return res;
  } catch (err) {
    console.error('❌ Failed to fetch products:', err);
    throw err;
  }
};

const getProductsBySupplierCode = async supplierCode => {
  return baseGetWithoutParam(`${API2_HOST}/sls-products/${supplierCode}`);
};

export {
  getByEmplasCode,
  getBySupplierCode,
  searchProductsStartsWith,
  searchProducts,
  getProductsBySupplierCode
};
